module.exports = __webpack_public_path__ + "img/icon-products-magento-65.5ba60c09.svg";